export default __webpack_public_path__ + "static/media/filterIcon.03e1edb5.svg";